import React from 'react';
import PropTypes from 'prop-types';

import { ViewerPrimaryColorUserStyle } from '../UserCustomization';

export default function MenuCloseButton({ onCloseClick }) {
  return (
    <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
      <button className="menu-close-button" type="button" onClick={onCloseClick}>&times;</button>
    </ViewerPrimaryColorUserStyle>
  );
}

MenuCloseButton.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/MapToolbar/MenuCloseButton.js